module.exports = __webpack_public_path__ + "static/282-7e7720683e82673c068ff6c32b265309.png";